import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./../../wrapper";
import { logInUserInfo } from "../../Actions/Users";
// import PaymentList from '../../Components/Payment'
import { PaymentList } from "../../Components/NewPayment";
import ConfirmDialoag from "../../Components/common/ConfirmDialoag";

import axios from "axios";
import instance from "../../axios";
import withRoutes from "../../HOC/HocRoutes";
import moment from "moment";
import { callActiveInactiveCron } from "../../Helpers";

let source;

/** Account / contract → c_* attributes for customer-receiving PDF */
const buildPaymentCustomerAttributes = (account = {}) => {
  if (!account || typeof account !== "object") return {};
  const nested = account.attributes || {};
  return {
    c_accountName:
      nested.c_accountName ||
      account.accountName ||
      account.name ||
      account.contractName ||
      account.label ||
      "",
    c_nameArabic:
      nested.c_nameArabic || account.nameArabic || account.nameAr || "",
    c_email: nested.c_email || account.email || "",
    c_contactName:
      nested.c_contactName ||
      nested.c_contact ||
      nested.c_customerName ||
      account.contactName ||
      "",
    c_customerNo:
      nested.c_customerNo ||
      nested.c_phone ||
      account.phone ||
      account.customerNo ||
      "",
    c_taxNumber:
      nested.c_taxNumber ||
      nested.c_VATNumber ||
      account.taxNumber ||
      account.vatNumber ||
      "",
    c_address:
      nested.c_address || nested.c_Location || account.address || "",
    c_addressArabic:
      nested.c_addressArabic ||
      nested.c_LocationArabic ||
      account.addressArabic ||
      "",
    c_city: nested.c_city || account.city || "",
    c_cityArabic: nested.c_cityArabic || account.cityArabic || "",
    c_contractNumber:
      nested.c_contractNumber || account.contractNumber || "",
    c_contractName:
      nested.c_contractName ||
      account.contractName ||
      account.accountName ||
      account.name ||
      "",
  };
};

const formDefault = {
  id: 0,
  attributes: {},
  refNum: "",
  type: true,
  amount: "",
  contractNumber: "",
  paymentMode: "",
  paymentDate: "",
  remarks: "",
  adjustmentType: "",
  parentId: 0,
  receipt: "",
  docs: " ",
  archive: null,
  archiveTime: null,
  recipientDate: "",
  invoiceIds: [],
  searchAccount: "",
  useCredit: false,
};
const formDefaultSettleAmount = {
  contractNumberForSettle: "",
  adjustAmount: 0,
  adjustmentType: "",
  invoiceIds: [],
};
class Payment extends Component {
  constructor(props) {
    super(props);
       const userTimeZone =
      props.loginUser?.timeZone || "Asia/Karachi";
    this.state = {
      payments: "",
      paymentList: "",
      form: { ...formDefault,  paymentDate: moment
    .tz(userTimeZone)
    .utc()
    .format("YYYY-MM-DDT00:00:00.000[Z]") },
      formSettleAmount: { ...formDefaultSettleAmount },
      selectedPayment: "",
      editOption: false,
      onDeleteConfirmation: false,
      itemAttributes: {},
      selectedGroup: "",
      isVisableAddBtn: false,
      isVisableSettleBtn: false,
      isVisable: false,
      activeOperation: "",
      selectedItem: "",
      openTable: false,
      users: "",
      addOption: false,
      to: "",
      from: "",
      account: "",
      vehcile: "",
      area: "",
      filteredData: false,
      selectedAccount: {},
      page: 1,
      pageSize: 20,
      loader: true,
      showPayments: false,
      openFilter: false,
      searchPayment: "",
      selectSingleAccount: false,
      paymentAccount: "",
      manualPayments: "",
      isChecked: false,
      selectedInvoices: [],
      totalInvoiceBalance: 0,
      // objects: [],
      creditAmount: "",
      creditAmountForSettle: "",
      contractType: 1,
      loader2: false,
      balanceError: "",
      // invoiceIds:[]
      invoiceLoader: false,
      invoiceSearch: "",
      paymentNumber: "",
      refNumber: "",
      settleAmountOption: false,
      overallInvoiceBalance: "",
      onSettleAmountConfirmation: false,
      // settlementForm: {
      //   adjustAmount: 0,
      //   adjustmentType: "",
      //   invoiceIds: "",
      // },
    };
    this.modalControle = this.modalControle.bind(this);
    this.addDevice = this.addDevice.bind(this);
  }

  allUsersId = (event, items) => {
    // for selecting single Invoice
    let allData = [];
    let totalBalance;
    // const roundedNum = Math.round(num * 100) / 100;
    if (event.target.checked) {
      let ids = Array.isArray(this.state.form.invoiceIds)
        ? [...this.state.form.invoiceIds, items.id]
        : [items.id];
      let cal = this.state.totalInvoiceBalance + items.invoicebalance;
      totalBalance = Math.round(cal * 100) / 100;
      this.setState(
        {
          totalInvoiceBalance: totalBalance,
          form: {
            ...this.state.form,
            invoiceIds: ids,
          },
        },
        () => this.checkRequiredFields()
      );
    } else {
      let ids = Array.isArray(this.state.form.invoiceIds)
        ? this.state.form.invoiceIds.filter((id) => id !== items.id)
        : [];
      let cal = this.state.totalInvoiceBalance - items.invoicebalance;
      totalBalance = Math.round(cal * 100) / 100;
      this.setState(
        {
          totalInvoiceBalance: totalBalance,
          form: {
            ...this.state.form,
            invoiceIds: ids,
          },
        },
        () => this.checkRequiredFields()
      );
    }

    this.state.manualPayments.map((it) => {
      if (it.id === items.id) {
        let row = {
          ...it,
          check: event.target.checked,
        };
        allData.push(row);
      } else {
        allData.push(it);
      }
    });

    this.setState({ manualPayments: allData }, () =>
      this.checkRequiredFields()
    );
  };

  selectAll = (e) => {
    let allData = [];
    let totalBalance;
    let ids = [];
    let cal = 0;
    this.state.manualPayments.map((it) => {
      let row = {
        ...it,
        check: e,
      };
      if (e) {
        cal = cal + it.invoicebalance;
        ids.push(it.id);
      } else {
        cal = 0;
        ids = [];
      }
      allData.push(row);
    });
    totalBalance = Math.round(cal * 100) / 100;
    this.setState(
      {
        totalInvoiceBalance: totalBalance,
        form: {
          ...this.state.form,
          invoiceIds: ids,
        },
      },
      () => this.checkRequiredFields()
    );
    this.setState(
      { manualPayments: allData, totalInvoiceBalance: totalBalance },
      () => this.checkRequiredFields()
    );
  };

  searchInvoices = (e) => {
    source.cancel();
    this.setState(
      {
        invoiceSearch: e.target.value,
      },
      () => {
        this.getInvoicesForSingleAccount();
      }
    );
  };
  getInvoicesForSingleAccount = () => {
    const { paymentAccount, selectedAccount, showPayments } = this.state;
    let url;
    let account;
    if (showPayments) {
      account = selectedAccount;
    } else {
      account = paymentAccount;
    }

    if (account.contractType === 1) {
      url = `api/invoices/unpaid/list?cn=${account.contractNumber}&invoiceNumber=${this.state.invoiceSearch}`;
    } else if (account.contractType === 2) {
      url = `api/leaseinvoices/unpaid/list?cn=${account.contractNumber}&search=${this.state.invoiceSearch}`;
    }
    source = axios.CancelToken.source();

    // this.setState({
    //   invoiceLoader : true,
    // },()=>{
    axios
      .get(url, {
        cancelToken: source.token,
      })
      .then((res) => {
        const filteredInvoices = res?.data?.data?.filter(
          (invoice) => invoice.invoicebalance > 0
        );
        let totalInvBalance = res?.data?.data?.reduce(
          (sum, item) => sum + item.invoicebalance,
          0
        );
        this.setState(
          {
            manualPayments: filteredInvoices,
            // isChecked: true,
            overallInvoiceBalance: totalInvBalance,
            invoiceLoader: false,
          },
          () => this.checkRequiredFields()
        );
      })
      .catch((error) => {
        // errorHandler(error, this.props.dispatch)
      });
    // })
  };

  getCredtit = () => {
    const { paymentAccount, selectedAccount, showPayments, searchAccount } =
      this.state;

    let account;
    let url;
    if (showPayments) {
      account = selectedAccount;
    } else {
      account = paymentAccount;
    }

    url = `api/payments/credit?cn=${account.contractNumber}`;

    instance({
      method: "GET",
      url: url,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        this.setState({
          creditAmount: res,
          // isChecked: true,
        });
        this.setState({ creditAmountForSettle: res }, () => {
          this.checkRequiredFields();
        });
      })
      .catch((error) => {
        // errorHandler(error, this.props.dispatch)
      });
  };

  handleChangeForAccount = async (name, event, link) => {
    const account = event || {};
    this.setState(
      {
        [name]: event,
        form: {
          ...this.state.form,
          contractNumber: account.contractNumber || "",
          attributes: {
            ...(this.state.form.attributes || {}),
            ...buildPaymentCustomerAttributes(account),
          },
          useCredit: true,
          invoiceLoader: true,
        },
      },
      () => {
        this.getInvoicesForSingleAccount();
        this.getCredtit();
        this.checkRequiredFields();
      }
    );
    // this.props.handleChange('useCredit')(event);
  };

  handleChange = (name) => (event) => {
    if (name === "useCredit") {
      if (event.target.checked) {
        this.setState((prevState) => ({
          form: {
            ...this.state.form,
            useCredit: true,
          },
        }));
      } else {
        this.setState((prevState) => ({
          form: {
            ...this.state.form,
            useCredit: false,
          },
        }));
      }
    } else if (name === "adjustmentType") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: event.target.value,
          },
          totalInvoiceBalance:0,
          invoiceLoader: event.target.value === "manual" ? true : false,
        },
        () => {
          this.checkRequiredFields();
          if (event.target.value === "manual") {
            this.getInvoicesForSingleAccount();
          }
        }
      );
    } else {
      let value =
        name === "amount" ? parseFloat(event.target.value) : event.target.value;

      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: value,
          },
        },
        () => this.checkRequiredFields()
      );
    }
  };

handleSubmit = async (event) => {
  let { form, selectedAccount, paymentAccount, showPayments } = this.state;
  const account = showPayments
    ? selectedAccount
    : paymentAccount || selectedAccount;
  const attributes = {
    ...(form.attributes || {}),
    ...buildPaymentCustomerAttributes(account),
  };
  const obj = {
    ...form,
    contractNumber: form.contractNumber || account?.contractNumber || "",
    attributes,
  };

  try {
    const result = await axios.post(`/api/payments`, obj);
    if (result.data.status === "success") {
      this.setState(
        {
          addOption: false,
          editOption: false,
          isVisableAddBtn: false,
          paymentAccount: "",
          totalInvoiceBalance: "",
          form: {
            refNum: "",
            amount: "",
            paymentMode: "",
            paymentDate: "",
            remarks: "",
            adjustmentType: "",
            recipientDate: "",
            contractNumber: "",
          },
          // selectedAccount: {},
        },
        () => {
          this.getPaymentList(selectedAccount.contractNumber)
          this.getSearchedPayments()
const cn = result?.data?.data?.contractNumber;

if (cn && typeof cn === "string" && cn.trim() !== "") {
  callActiveInactiveCron(cn);
}

        }
      );

      toast.success(this.props.translate("paymentAdded"));
    } else {
      let message = result?.data?.message||"Something went wrong";
      const splitString = message.split(": ");
      if (splitString.length >= 2) {
        message = splitString[1];
      }
      toast.error(this.props.translate(message));
    }
  } catch (error) {
    console.warn("Payment submit error:", error?.message || error);
    toast.error(this.props.translate("somethingWentWrong"));
  }
};


  getAccounts = () => {
    if (this.props.logInUser && this.props.logInUser.id) {
      instance({
        method: "GET",
        url: `api/accounts/get?userId=${this.props.logInUser.id}&all=true&limit=20&page=1`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          this.setState({
            users: res.data,
          });
        })
        .catch((error) => {
          // errorHandler(error, this.props.dispatch)
        });
    }
  };
  //
  // handleChangeLicenseExpDate = (name, event) => {
  //   if (name === "paymentDate" || name === "recipientDate") {
  //     const dateValue = event ? event.toISOString() : null;
  //     this.setState(
  //       {
  //         form: {
  //           ...this.state.form,
  //           [name]: dateValue,
  //         },
  //       },
  //       () => this.checkRequiredFields()
  //     );
  //   }
  // };

  handleChangeLicenseExpDate = (name, event) => {
    let serverTimeZone = "";
    if (
      this.props.logInUser &&
      this.props.logInUser.attributes &&
      this.props.logInUser.attributes.timezone
    ) {
      serverTimeZone = this.props.logInUser.attributes.timezone;
    } else {
      serverTimeZone = "Asia/Riyadh";
    }

    // if (name === "paymentDate" || name === "recipientDate") {
    //   const dateValue = event
    //     ? moment.tz(event, serverTimeZone).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
    //     : null;
    //   this.setState(
    //     {
    //       form: {
    //         ...this.state.form,
    //         [name]: dateValue,
    //       },
    //     },
    //     () => this.checkRequiredFields()
    //   );
    // }

    if (name === "paymentDate" || name === "recipientDate") {
      const dateValue = event
        ? moment(event).endOf("day").utc().format("YYYY-MM-DDT00:00:00.000[Z]")
        : null;
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: dateValue,
          },
        },
        () => this.checkRequiredFields()
      );
    }
  };

  updatePayment = async () => {
    const { selectedPayment, form } = this.state;
    const obj = { ...form };
    let result = await axios.put(`/api/payments/${selectedPayment.id}`, obj);
    if (result.data.status === "success") {
      this.setState({
        addOption: false,
        editOption: false,
        isVisableAddBtn: false,
      });

      toast.success(this.props.translate("Payment Updated"));
    } else {
      toast.error(this.props.translate(result.data.message));
    }
  };

  deletePayment = async () => {
    const { selectedPayment } = this.state;
    let result = await axios.delete(`/api/payments/${selectedPayment.id}`);
    if (result.data.status === "success") {
      // this.getFilteredPAyments(this.state.to,this.state.from,this.state.account,this.state.vehcile,this.state.area)

      toast.success(this.props.translate("Payment Deleted"));
    } else {
      toast.error(this.props.translate(result.data.message));
    }
  };

  addDevice() {
    this.setDefaultForm({ keepContractNumber: !!this.state.showPayments });
    this.setState({
      addOption: true,
      settleAmountOption: false,
      editOption: false,
    });
  }

  paymentSelection = async (item) => {
    if (item) {
      await this.setState({
        // defaultDeviceList: false,
        selectedPayment: item[0],
        editOption: true,
        form: { ...item[0] },
      });
    }
  };

  onCancel = () => {
    this.setState({
      onDeleteConfirmation: false,
    });
  };
  // componentDidMount() {
  //   this.getAccounts();
  // }
  componentWillUnmount() {
    if (source) {
      source.cancel();
    }
  }

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  setPagination = (items) => {
    let nItem = { ...items };
    let lastPage = nItem.total / this.state.pageSize;
    let IsFloate = this.checkFloteNumber(lastPage);
    delete nItem.data;
    nItem.pageSize = this.state.pageSize;
    nItem.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
    return nItem;
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    if (this.state.filteredData || this.state.openFilter) {
      this.setState({ page: 1, pageSize: rowsPerPage }, () => {
        this.getFilteredPAyments(
          this.state.to,
          this.state.from,
          this.state.account,
          this.state.vehcile,
          this.state.area
        );
      });
    } else {
      this.setState({ page: 1, pageSize: rowsPerPage }, () => {
        this.getPaymentList(this.state.selectedAccount.contractNumber);
      });
    }
  };

  handleChangePage = (value) => {
    if (this.state.filteredData || this.state.openFilter) {
      this.setState({ page: value }, () => {
        this.getFilteredPAyments(
          this.state.to,
          this.state.from,
          this.state.account,
          this.state.vehcile,
          this.state.area
        );
      });
    } else {
      this.setState({ page: value }, () => {
        this.getPaymentList(this.state.selectedAccount.contractNumber);
      });
    }
  };
  openFilters = (type) => {
    this.setState(
      {
        to: "",
        from: "",
        account: "",
        vehcile: "",
        area: "",
        openFilter: true,
        showPayments: false,
        filteredData: false,
        form: {
          contractNumber: this.props?.ServerSetting?.contractNumber,
        },
        selectedAccount: this.props?.ServerSetting,
      },
      () =>
        this.getFilteredPAyments(
          this.state.to,
          this.state.from,
          this.state.account,
          this.state.vehcile,
          this.state.area,
          type
        )
    );
  };

  paymentFilter = async (to, from, account, vehcile, area) => {
    this.setState(
      {
        // selectedAccount:item,
        to: to,
        from: from,
        account: account,
        vehcile: vehcile,
        area: area,
        page: 1,
        pageSize: 20,
        itemSearch: "",
        filteredData: true,
      },
      () => {
        this.getFilteredPAyments(to, from, account, vehcile, area);
      }
    );
  };

downloadInvoices = async (to, from, account, vehicle, area, type) => {
  try {
    const contractNumber = this.state.showPayments
      ? `&cn=${this.state.form.contractNumber}`
      : account
      ? account
      : "";

    const accept =
      type === "downloadPdf"
        ? "application/pdf"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    const headers = new Headers({
      "Content-Type": "application/json",
      Accept: accept,
    });

    const response = await fetch(
      `/api/payments/export?to=${to}&from=${from}${contractNumber}`,
      {
        method: "GET",
        headers,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `Request failed with status ${response.status}`);
    }

    const blob = await response.blob();
    const fileName = type === "downloadPdf" ? "payments.pdf" : "payments.xlsx";

    this.setState(
      {
        selectedAreaId: "",
        selectedvehicleId: "",
        to: "",
        from: "",
        loader: false,
      },
      () => {
        this.saveData(blob, fileName);
      }
    );
  } catch (error) {
    console.error("Download invoices failed:", error);
    this.setState({ loader: false }); // ensure loader resets even on error
  }
};


  saveData = (blob, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      const a = document.createElement("a");
      document.body.appendChild(a);
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = filename;
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        // this.setState({ loading: false })
      }, 0);
    }
    // this.setState({ loading: false })
  };
  getSearchedPayments = () => {
    this.setState({
page:1,
    },()=>{
      this.getFilteredPAyments(
        this.state.to,
        this.state.from,
        this.state.account,
        this.state.vehcile,
        this.state.area,
        ""
      );
    })

  };

  getFilteredPAyments = (to, from, account, vehcile, area, type) => {
    let {
      page,
      pageSize,
      searchPayment,
      contractType,
      showPayments,
      selectedAccount,
      paymentNumber,
      refNumber,
    } = this.state;
    let apiUrl;
    if (showPayments) {
      // inCase of selecting single account
      if (to) {
        apiUrl = `/api/payments/get?cn=${selectedAccount?.contractNumber}&to=${to}&from=${from}${account}${vehcile}${area}&page=${page}&limit=${pageSize}&paymentNumber=${paymentNumber}&refNumber=${refNumber}`;
      } else {
        apiUrl = `/api/payments/get?cn=${selectedAccount?.contractNumber}&page=${page}&limit=${pageSize}&paymentNumber=${paymentNumber}&refNumber=${refNumber}`;
      }
    } else {
      if (to) {
        apiUrl = `/api/payments/get?&contractType=${contractType}&to=${to}&from=${from}${account}${vehcile}${area}&page=${page}&limit=${pageSize}&paymentNumber=${paymentNumber}&refNumber=${refNumber}`;
      } else {
        apiUrl = `/api/payments/get?&contractType=${contractType}&page=${page}&limit=${pageSize}&paymentNumber=${paymentNumber}&refNumber=${refNumber}`;
      }
    }
    source = axios.CancelToken.source();
    this.setState(
      {
        loader2: true,
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            this.setState({
              filteredData: true,
              paymentList: response?.data?.data || [],
              openTable: true,
              loader: false,

              loader2: false,
            });
          })
          .catch((e) => {
            // console.log("e ===", e);
          });
      }
    );
  };

  SearchItem = (e, name) => {
    source.cancel();
    if (this.state.filteredData || this.state.openFilter) {
      if (name === "paymentNumber" || name === "refNumber") {
        this.setState(
          {
            [name]: e.target.value,
          }
          // () =>
          //   this.getFilteredPAyments(
          //     this.state.to,
          //     this.state.from,
          //     this.state.account,
          //     this.state.vehcile,
          //     this.state.area,
          //     ""
          //   )
        );
      }
    } else {
      this.setState(
        {
          searchPayment: e.target.value,
        },
        () => {
          this.getPaymentList(this.state.selectedAccount.contractNumber);
        }
      );
    }
  };

  getPaymentList = (id) => {
    let { page, pageSize, searchPayment } = this.state;
    // &search=${searchPayment}
    let apiUrl;
    source = axios.CancelToken.source();

    apiUrl = `/api/payments/get?cn=${id}&page=${page}&limit=${pageSize}&search=${searchPayment}`;
    this.setState(
      {
        loader: true,
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            this.setState({
              payments: response?.data?.data || [],
              // paymentList: result.data.data,
              filteredData: false,
              openTable: true,
              loader: false,
            });
          })
          .catch((e) => {
            // console.log("e ===", e);
          });
      }
    );
  };



  setContractType = (value) => {
    this.setState({
      contractType: value,
    });
  };

  setDefaultForm = (options = {}) => {
    const { keepContractNumber = false, resetSettle = true } = options;
    const userTimeZone = this.props.loginUser?.timeZone || "Asia/Karachi";
    const paymentDate = moment
      .tz(userTimeZone)
      .utc()
      .format("YYYY-MM-DDT00:00:00.000[Z]");

    const nextState = {
      form: {
        ...formDefault,
        paymentDate,
        contractNumber:
          keepContractNumber || this.state.showPayments
            ? this.state.form?.contractNumber || ""
            : "",
      },
      isVisableAddBtn: false,
      balanceError: "",
      creditAmountForSettle: "",
      overallInvoiceBalance: "",
      totalInvoiceBalance: 0,
      selectedInvoices: [],
      isChecked: false,
    };

    if (resetSettle) {
      nextState.formSettleAmount = { ...formDefaultSettleAmount };
      nextState.paymentAccount = this.state.showPayments
        ? this.state.paymentAccount
        : "";
      nextState.isVisableSettleBtn = false;
    }

    this.setState(nextState);
  };

  //  --------------------------------------Settelemt Settings-------------------------------------------------------------

  settleAmount = () => {
    this.setDefaultForm({ resetSettle: true });
    this.setState({
      settleAmountOption: true,
      addOption: false,
      editOption: false,
    });
  };

  allUsersId1 = (event, items) => {
    // for selecting single Invoice
    let allData = [];
    let totalBalance;
    // const roundedNum = Math.round(num * 100) / 100;
    if (event.target.checked) {
      let ids = Array.isArray(this.state.formSettleAmount.invoiceIds)
        ? [...this.state.formSettleAmount.invoiceIds, items.id]
        : [items.id];
      let cal = this.state.totalInvoiceBalance + items.invoicebalance;
      totalBalance = Math.round(cal * 100) / 100;
      this.setState(
        {
          totalInvoiceBalance: totalBalance,
          formSettleAmount: {
            ...this.state.formSettleAmount,
            invoiceIds: ids,
          },
        },
        () => this.checkRequiredFields1()
      );
    } else {
      let ids = Array.isArray(this.state.formSettleAmount.invoiceIds)
        ? this.state.formSettleAmount.invoiceIds.filter((id) => id !== items.id)
        : [];
      let cal = this.state.totalInvoiceBalance - items.invoicebalance;
      totalBalance = Math.round(cal * 100) / 100;
      this.setState(
        {
          totalInvoiceBalance: totalBalance,
          formSettleAmount: {
            ...this.state.formSettleAmount,
            invoiceIds: ids,
          },
        },
        () => this.checkRequiredFields1()
      );
    }

    this.state.manualPayments.map((it) => {
      if (it.id === items.id) {
        let row = {
          ...it,
          check: event.target.checked,
        };
        allData.push(row);
      } else {
        allData.push(it);
      }
    });

    this.setState({ manualPayments: allData }, () =>
      this.checkRequiredFields1()
    );
  };

  selectAll1 = (e) => {
    let allData = [];
    let totalBalance;
    let ids = [];
    let cal = 0;
    this.state.manualPayments.map((it) => {
      let row = {
        ...it,
        check: e,
      };
      if (e) {
        cal = cal + it.invoicebalance;
        ids.push(it.id);
      } else {
        cal = 0;
        ids = [];
      }
      allData.push(row);
    });
    totalBalance = Math.round(cal * 100) / 100;
    this.setState(
      {
        totalInvoiceBalance: totalBalance,
        formSettleAmount: {
          ...this.state.formSettleAmount,
          invoiceIds: ids,
        },
      },
      () => this.checkRequiredFields1()
    );
    this.setState(
      { manualPayments: allData, totalInvoiceBalance: totalBalance },
      () => this.checkRequiredFields1()
    );
  };

  modalControle() {
    this.setDefaultForm({ keepContractNumber: !!this.state.showPayments });
    this.setState({
      isVisableAddBtn: false,
      isVisableSettleBtn: false,
      addOption: false,
      editOption: false,
      settleAmountOption: false,
      totalInvoiceBalance: 0,
      selectedInvoices: [],
      pageSize: 20,
    });
  }

  goBack = () => {
    this.setDefaultForm();
    this.setState({
      addOption: false,
      settleAmountOption: false,
      editOption: false,
      showPayments: false,
      openFilter: false,
      totalInvoiceBalance: 0,
      selectedInvoices: [],
      paymentNumber: "",
      refNumber: "",
      searchPayment: "",
      pageSize: 20,
    });
  };

  checkRequiredFields = () => {
    const {
      refNum,
      amount,
      paymentMode,
      adjustmentType,
      recipientDate,
      paymentDate,
      contractNumber,
      invoiceIds,
    } = this.state.form;

    if (
      refNum &&
      amount &&
      paymentMode &&
      adjustmentType &&
      recipientDate &&
      paymentDate &&
      contractNumber &&
      amount
    ) {
      // if (adjustmentType === "manual") {
      //   if (invoiceIds?.length > 0) {
      //     this.setState({ isVisableAddBtn: true });
      //   } else {
      //     this.setState({ isVisableAddBtn: false });
      //   }
      // } else {
      this.setState({ isVisableAddBtn: true, balanceError: "" });
      // }
    } else {
      this.setState({ isVisableAddBtn: false, balanceError: "" });
    }
  };

  singlePaymentSelection = (type) => {
    // console.log("paymentAccount=====", type);
    this.setState(
      {
        to: "",
        from: "",
        account: type?.contractNumber,
        vehcile: "",
        area: "",
        openFilter: false,
        showPayments: true,
        filteredData: false,
        form: {
          contractNumber: type?.contractNumber,
          attributes: buildPaymentCustomerAttributes(type),
        },
        selectedAccount: type,
        formSettleAmount: {
          contractNumberForSettle: type.contractNumber,
        },
        // paymentAccount: type,
        // isVisableSettleBtn: true,
      },
      () => {
        this.getFilteredPAyments(
          this.state.to,
          this.state.from,
          this.state.account,
          this.state.vehcile,
          this.state.area,
          type
        );
        this.checkRequiredFields();
        this.checkRequiredFields1();
      }
    );
  };

  checkRequiredFields1 = () => {
    const {
      contractNumberForSettle,
      adjustAmount,
      adjustmentType,
      invoiceIds,
    } = this.state.formSettleAmount;
    const { creditAmountForSettle, overallInvoiceBalance } = this.state;

    if (
      contractNumberForSettle &&
      creditAmountForSettle &&
      overallInvoiceBalance
    ) {
      if (adjustmentType === "manual") {
        if (
          adjustAmount <= creditAmountForSettle &&
          adjustAmount <= overallInvoiceBalance &&
          adjustAmount>0&&
          invoiceIds?.length > 0
        ) {
          this.setState({ isVisableSettleBtn: true });
        } else {
          this.setState({ isVisableSettleBtn: false });
        }
      } else {
        this.setState({ isVisableSettleBtn: true });
      }
    } else {
      this.setState({ isVisableSettleBtn: false });
    }
  };
  handleChangeSettleAmount = (name, event) => {
    if (event) {
      if (name === "adjustAmount" || name === "adjustmentType") {
        this.setState(
          {
            formSettleAmount: {
              ...this.state.formSettleAmount,
              [name]: event.target.value,
            },
            // isVisableSettleBtn: true,
          },
          () => {
            this.checkRequiredFields1();
            // this.getInvoicesForSingleAccount();
            // this.getCredtit();
          }
        );
      } else {
        this.setState(
          {
            [name]: event,
            formSettleAmount: {
              ...this.state.formSettleAmount,
              contractNumberForSettle: event.contractNumber,
            },
            // isVisableSettleBtn: true,
          },
          () => {
            this.checkRequiredFields1();
            this.getInvoicesForSingleAccount();
            this.getCredtit();
          }
        );
      }
    } else {
      this.setDefaultForm();
    }
  };

  onCancelSettle = () => {
    this.setState({ onSettleAmountConfirmation: false });
  };
  onOKSettle = () => {
    this.setState({ onSettleAmountConfirmation: false }, () => {
      this.handleSubmitSettleAmount();
    });
  };
  onConfirmSettle = () => {
    this.setState({ onSettleAmountConfirmation: true });
  };
  handleSubmitSettleAmount = async () => {
    const { formSettleAmount } = this.state;
    const {
      contractNumberForSettle,
      adjustmentType,
      adjustAmount,
      invoiceIds,
    } = formSettleAmount;

    let url;

    // Conditional URL construction based on adjustmentType
    if (adjustmentType === "manual") {
      // Convert invoiceIds array into query parameters
      const invoiceIdsParam = invoiceIds
        ?.map((id) => `invoiceIds=${id}`)
        ?.join("&");
      url = `/api/payments/settle?contractNumber=${contractNumberForSettle}&adjustAmount=${adjustAmount}&${invoiceIdsParam}`;
    } else if (adjustmentType === "fifo") {
      url = `/api/payments/settle?contractNumber=${contractNumberForSettle}`;
    }
    instance({
      method: "GET",
      url: url,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        // Reset form and state
        this.setState({
          form: {
            ...formDefault,
            contractNumber: this.state.showPayments
              ? this.state.form.contractNumber
              : "",
          },
          formSettleAmount: {},
          paymentAccount: "",
          isVisableSettleBtn: false,
          creditAmountForSettle: "",
          overallInvoiceBalance: "",
          settleAmountOption: false,
        });
        if(contractNumberForSettle){
          callActiveInactiveCron(contractNumberForSettle)
        }
        toast.success(this.props.translate("settledAmountSuccessful"));
      })
      .catch((error) => {
        // Handle and display error message
        let result1;
        const splitString = error.message.split(": ");
        if (splitString.length >= 2) {
          result1 = splitString[1]; // Take the second part after splitting
        }

        toast.error(this.props.translate(result1));
      });
  };

  render() {
    if (this.props.logInUser) {
      return (
        <Layout
          {...this.state}
          {...this.props}
          paymentFilter={this.paymentFilter}
          downloadInvoices={this.downloadInvoices}
          noSidebar={
            this.state.openFilter || this.state.showPayments ? "" : "noSidebar"
          }
        >
          <PaymentList
            {...this.state}
            {...this.props}
            allUsersId1={this.allUsersId1}
            selectAll1={this.selectAll1}
            getSearchedPayments={this.getSearchedPayments}
            searchInvoices={this.searchInvoices}
            users={this.state.users}
            payments={this.state.payments}
            paymentList={
              this.state.openFilter || this.state.filteredData
                ? this.state.paymentList
                : this.state.payments
            }
            setDefaultForm={this.setDefaultForm}
            goBack={this.goBack}
            setContractType={this.setContractType}
            selectAll={this.selectAll}
            SearchItem={this.SearchItem}
            addDevice={this.addDevice}
            addOption={this.state.addOption}
            settleAmount={this.settleAmount}
            settleAmountOption={this.state.settleAmountOption}
            handleSubmit={this.handleSubmit}
            data={this.state.form}
            handleChangeForAccount={this.handleChangeForAccount}
            handleChange1={this.handleChangeSettleAmount}
            handleSubmitSettleAmount={this.onConfirmSettle}
            creditAmountForSettle={this.state.creditAmountForSettle}
            overallInvoiceBalance={this.state.overallInvoiceBalance}
            allUsersId={this.allUsersId}
            handleChange={this.handleChange}
            editOption={this.state.editOption}
            paymentSelection={this.paymentSelection}
            selectedPayment={this.state.selectedPayment}
            updatePayment={this.updatePayment}
            removeEnable={this.removeEnable}
            onDeleteConfirmation={this.state.onDeleteConfirmation}
            modalControle={this.modalControle}
            deletePayment={this.deletePayment}
            onCancel={this.onCancel}
            // editEnable={this.editEnable}
            setPagination={this.setPagination}
            isVisableAddBtn={this.state.isVisableAddBtn}
            isVisableSettleBtn={this.state.isVisableSettleBtn}
            checkRequiredFields={this.checkRequiredFields}
            handleChangeLicenseExpDate={this.handleChangeLicenseExpDate}
            handleChangePage={this.handleChangePage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            selectedAccount={this.state?.selectedAccount || {}}
            showPayments={this.state.showPayments}
            accountSelection={this.accountSelection}
            // selecteItem={this.selecteItem}
            singlePaymentSelection={this.singlePaymentSelection}
            openFilter={this.state.openFilter}
            openFilters={this.openFilters}
          />
          {this.state.onSettleAmountConfirmation && (
            <ConfirmDialoag
              onCancel={this.onCancelSettle}
              onOk={this.onOKSettle}
              title={this.props.translate(
                "Do You want to Settle Outstanding Payment from Advance Payment?"
              )}
            />
          )}
        </Layout>
      );
    } else {
      fetch(
        "/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05",
        {
          headers: { Accept: "application/json; odata=verbose" },
        }
      )
        .then((response) => {
          if (response.ok) {
            response.json().then((res) => {
              if (res.status === "success") {
                let userInfo = res.data;
                this.props.setActiveLanguage(
                  userInfo?.attributes?.lang || "en"
                );
                this.props.dispatch(logInUserInfo(userInfo));
              } else if (res?.statusCode === "440") {
                window.location.replace("/login");
              } else if (res.statusCode) {
                var err = res?.message.split(":");
                err[1] = err[1].replace(")", "");

                toast.error(this.props.translate(err[1]));
                this.props.navigate("/login");
              }
            });
          } else {
            this.props.navigate("/login");
            throw response;
          }
        })
        .catch((e) => {
          toast.error("somethingWentWrong");
        });
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
});

export default connect(mapStateToProps)(withRoutes(Payment));
